import { ThemeProvider } from "@bonusx-global/bx-design-system";
import CssBaseline from "@mui/material/CssBaseline";
import StyledEngineProvider from "@mui/material/StyledEngineProvider";
import type { PropsWithChildren } from "react";
import { ErrorBoundary } from "react-error-boundary";
import useIsMobile from "../../../hooks/device/useIsMobile";
import { Modal } from "../../../legacy/components/poppers/Modal";
import { handleErrorBoundaryError } from "../../../lib/error-boundary/handle-error-boundary-error";
import citizenTheme, { citizenThemeWhiteBg } from "../../../legacy/styles/citizenTheme";
import ErrorBoundaryFallback from "../../blocks/ErrorBoundaryFallback/ErrorBoundaryFallback";
import DefaultLayoutDesktop from "./components/DefaultLayoutDesktop";
import DefaultLayoutMobile from "./components/DefaultLayoutMobile";

export interface DefaultLayoutProps extends PropsWithChildren<{}> {
  isLogoClickable?: boolean;
  variant?: "white" | "default";
}

function DefaultLayout({
  children,
  isLogoClickable = true,
  variant = "default",
}: Readonly<DefaultLayoutProps>): JSX.Element {
  const isMobile = useIsMobile();

  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={variant === "white" ? citizenThemeWhiteBg : citizenTheme}>
        <CssBaseline />
        <Modal />
        <ErrorBoundary FallbackComponent={ErrorBoundaryFallback} onError={handleErrorBoundaryError}>
          {isMobile ? (
            <DefaultLayoutMobile isLogoClickable={isLogoClickable}>{children}</DefaultLayoutMobile>
          ) : (
            <DefaultLayoutDesktop isLogoClickable={isLogoClickable}>{children}</DefaultLayoutDesktop>
          )}
        </ErrorBoundary>
      </ThemeProvider>
    </StyledEngineProvider>
  );
}

export default DefaultLayout;
